module.exports = __webpack_public_path__ + "img/03RockwellAutomation.d26fbfc0.jpg";